import { useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';

const STORAGE_KEY = 'lbc-agent-theme';
export function readTheme() {
  try { return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark'; }
  catch { return 'dark'; }
}
export function applyTheme(theme) {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
}
// Apply before React paints, including after a page reload.
applyTheme(readTheme());

export default function ThemeToggle() {
  const [theme, setTheme] = useState(readTheme);
  useEffect(() => {
    const sync = (event) => {
      if (event.key === STORAGE_KEY || event.key === null) {
        const next = readTheme(); applyTheme(next); setTheme(next);
      }
    };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);
  const toggle = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    applyTheme(next); setTheme(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* Preference still works for this visit. */ }
  };
  const isLight = theme === 'light';
  const Icon = isLight ? Moon : Sun;
  return <button type="button" className="theme-toggle" onClick={toggle}
    data-testid="theme-toggle" aria-label={isLight ? 'Activer le mode sombre' : 'Activer le mode clair'}
    title={isLight ? 'Passer au mode sombre' : 'Passer au mode clair'}>
    <Icon size={20} aria-hidden="true" />
    <span>Mode {isLight ? 'sombre' : 'clair'}</span>
  </button>;
}
